export interface AvatarDesign {
  skinTone: number;
  hairColor: number;
  hairStyle: string;
  eyeStyle: string;
  mouthStyle: string;
  beardStyle: string;
  wearsGlasses: boolean;
  raisedBrows: boolean;
  background: string;
}
export interface AvatarCatalog {
  version: number;
  defaults: AvatarDesign;
  hairStyles: readonly string[];
  eyeStyles: readonly string[];
  mouthStyles: readonly string[];
  beardStyles: readonly string[];
  backgrounds: readonly string[];
  skinColors: readonly string[];
  hairColors: readonly string[];
  skin: readonly string[];
  face: { eyes: Record<string, string>; mouths: Record<string, string>; glasses: string }[];
  hair: { styles: Record<string, string>; beards: Record<string, string>; brows: string[] }[];
}
export interface AccountAppearance {
  design: AvatarDesign;
  avatarUrl: string | null;
  version: number;
  photoUrl: string | null;
  photoVersion: number;
}

/** Render as an image, never as HTML. All layers originate from our versioned catalog. */
export const avatarSvg = (catalog: AvatarCatalog, design: AvatarDesign): string => {
  const face = catalog.face[design.skinTone];
  const hair = catalog.hair[design.hairColor];
  if (!face || !hair) throw new Error('Catalogue d’avatars incompatible. Rechargez la page.');
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" role="img" aria-label="Avatar">` +
    (design.background === 'none'
      ? ''
      : `<rect width="100" height="100" rx="16" fill="${design.background}"/>`) +
    catalog.skin[design.skinTone] +
    hair.beards[design.beardStyle] +
    face.eyes[design.eyeStyle] +
    hair.brows[Number(design.raisedBrows)] +
    face.mouths[design.mouthStyle] +
    (design.wearsGlasses ? face.glasses : '') +
    hair.styles[design.hairStyle] +
    '</svg>'
  );
};
export const avatarSource = (catalog: AvatarCatalog, design: AvatarDesign) =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(avatarSvg(catalog, design))}`;
export const randomDesign = (catalog: AvatarCatalog): AvatarDesign => {
  const pick = <T>(values: readonly T[]): T => values[Math.floor(Math.random() * values.length)]!;
  return {
    skinTone: Math.floor(Math.random() * catalog.skin.length),
    hairColor: Math.floor(Math.random() * catalog.hair.length),
    hairStyle: pick(catalog.hairStyles),
    eyeStyle: pick(catalog.eyeStyles),
    mouthStyle: pick(catalog.mouthStyles),
    beardStyle: pick(catalog.beardStyles),
    wearsGlasses: Math.random() < 0.3,
    raisedBrows: Math.random() < 0.4,
    background: pick(catalog.backgrounds),
  };
};
export const appearanceError = (error: unknown) =>
  error instanceof Error ? error.message : 'Impossible d’enregistrer. Réessayez.';
